import React, { Children, cloneElement, isValidElement, useCallback } from 'react';
import { MultiSelectDesktop } from "./components/MultiSelectDesktop/MultiSelectDesktop.js";
import { MultiSelectMobile } from "./components/MultiSelectMobile/MultiSelectMobile.js";
import { MultiSelectTag } from "./components/MultiSelectTag/MultiSelectTag.js";
import { useIsMobile } from "../../helper/hooks/useIsMobile.js";
import styles from "./MultiSelect.module.js";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
export const MultiSelect = ({
  activeItems,
  setActiveItems,
  showTags = true,
  searchable = false,
  submitButtonCaption,
  variant = 'secondary',
  children,
  ...rest
}) => {
  const isMobileDevice = useIsMobile();
  const addItem = useCallback(item => {
    setActiveItems(activeItems => [...activeItems, item]);
  }, [setActiveItems]);
  const removeItem = useCallback(item => {
    setActiveItems(activeItems => activeItems.filter(value => value !== item));
  }, [setActiveItems]);
  const _children = Children.map(children, (child, index) => {
    if (! /*#__PURE__*/isValidElement(child)) {
      return null;
    }
    const props = {
      active: activeItems.includes(child.props.value),
      'data-index': index
    };
    return /*#__PURE__*/cloneElement(child, props);
  })?.filter(Boolean);
  const activeChildren = _children.filter(child => child.props.active);
  const inputValue = activeChildren.map(child => child.props.label).join(' / ');
  return /*#__PURE__*/_jsxs("div", {
    children: [isMobileDevice ? /*#__PURE__*/_jsx(MultiSelectMobile, {
      submitButtonCaption: submitButtonCaption,
      inputValue: inputValue,
      activeItems: activeItems,
      setActiveItems: setActiveItems,
      ...rest,
      children: _children
    }) : /*#__PURE__*/_jsx(MultiSelectDesktop, {
      inputValue: inputValue,
      addItem: addItem,
      removeItem: removeItem,
      activeItems: activeItems,
      searchable: searchable,
      ...rest,
      children: _children
    }), showTags && /*#__PURE__*/_jsx("div", {
      className: styles.tagContainer,
      children: activeChildren.map(child => /*#__PURE__*/_jsx(MultiSelectTag, {
        disabled: rest.disabled,
        onClick: () => removeItem(child.props.value),
        label: child.props.label,
        variant: variant
      }, child.props.label))
    })]
  });
};